import './_autocomplete-search-collection-hits.scss';
import component from './autocomplete-search-collection-hits';

export default component;
